import { generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { PlanI18nEditContainer } from "@/components/features/items/edit/plan/standard-plan/i18n/ui/existing/container";

import { useGetPlanI8nEditPageParams } from "./_hooks/use-get-plan-i18n-edit-page-params";

export const PlanI18nEditPage = () => {
	const { hotelID, planID, langCode } = useGetPlanI8nEditPageParams();

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT, { hotelID, planID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.I18N, { hotelID, planID, langCode }),
	};

	return (
		<PageMeta
			title="プランの編集"
			url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.I18N, { hotelID, planID, langCode })}
		>
			<PlanI18nEditContainer hotelID={hotelID} planID={planID} activeLangCode={langCode} navigator={navigator} />
		</PageMeta>
	);
};

PlanI18nEditPage.displayName = "PlanI18nEditPage";
